import { DATE_FORMAT_LONG_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';

import { getDecisionActEventValidate } from './getDecisionActEventValidate';

interface IGetDecisionActEventsValidateProps {
  events: IKnmErknmFormEvent[] | undefined;
  isInteractionCategoryOrInspectorRequired: boolean | undefined;
  holdingDateTime: string | undefined;
  eventsDecision?: IKnmErknmFormEvent[];
}

export const getDecisionActEventsValidate = ({
  events,
  isInteractionCategoryOrInspectorRequired,
  holdingDateTime,
  eventsDecision,
}: IGetDecisionActEventsValidateProps): FormErrors<IKnmErknmFormEvent>[] | string | undefined => {
  if (!events || !events?.length) {
    return undefined;
  }

  const holdingDate = formatDate({
    date: holdingDateTime || '',
    dateFormat: DATE_FORMAT_LONG_FNS,
    parseFormat: DATE_FORMAT_LONG_MINUTE_FNS,
  });

  return events?.map(item =>
    getDecisionActEventValidate(item, holdingDate, isInteractionCategoryOrInspectorRequired, eventsDecision),
  );
};
